// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"85":"mobile","339":"storefront","394":"rimless","533":"safety","696":"promo","884":"admin"}[chunkId] || chunkId) + "." + {"18":"769081b7","73":"19c750e6","85":"1b39b07c","339":"9f0af78e","394":"f463022d","533":"8412a461","556":"b2d7ef72","696":"e75a0abb","884":"b3e3f7b3"}[chunkId] + ".chunk.js";
};